import merge from 'deepmerge'

const mergeConfig: merge.Options = {
  customMerge(key) {
    return key === '__typename' ? (_, b) => b : (a, b) => merge(a, b, mergeConfig)
  },
}

const createFixtureGenerator =
  <T extends Maybe<Record<string, unknown>>>({ defaults }: { defaults: T }) =>
  (overrides: Partial<T> = {}) =>
    merge(defaults || {}, overrides, mergeConfig) as T

export default createFixtureGenerator
